import React from 'react';
import ProcessItem from './ProcessItem';

function Process() {
  return (
    <section className="work-process-wrapper section-padding">
      <div className="container text-center">
        <div className="section-head">
          <span className="heading-bg">Steps</span>
          <h2 className="section-title mb-30">
            Our work process
            <span className="heading-dot" />
          </h2>
        </div>
        <div className="row">
          <ProcessItem
            number="01"
            heading="Request Sending"
            text="Send us a request and we will contact you within 15 minutes."
          />
          <ProcessItem
            number="02"
            heading="Project planing"
            text="At this stage, we create a clear plan for your project."
          />
          <ProcessItem
            number="03"
            heading="Enjoyning work"
            text="We deliver the project on time, taking into account the workload."
          />
        </div>
      </div>
    </section>
  );
}

export default Process;
